import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

export const getPagamento = async () => {
  const url = API_CONSTANT_MAP.pagamento;
  return requestApi.get(url);
};

export const postPagamento = (payload: any) => {
  return requestApi.post(API_CONSTANT_MAP.pagamento, payload);
};

export const getPagamentoById = async (id: string) => {
  const url = `${API_CONSTANT_MAP.pagamento}/${id}`;
  return requestApi.get(url);
};
